__turbopack_context__.v({
  "bannerBg": "J6sC4q_bannerBg",
  "referFriendBg": "J6sC4q_referFriendBg",
});
